const appVersion = process.env.NEXT_PUBLIC_APP_VERSION ?? '0.0.0';
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE ?? 'dev';

export const Build = release;

export const Version = appVersion;

export const Package = {
    version: Version,
    country: 'us',
    package: 'com.justsalad.web',
    build: Build
};

export default Version;
